export const getUserAbilities = () => {
  try {
    return JSON.parse(localStorage.getItem("userAbility") || "[]");
  } catch (e) {
    return [];
  }
};

export const hasAbility = (allowedAbilities = []) => {
  const abilities = getUserAbilities();
  if (Array.isArray(abilities)) {
    return abilities.some(
      (ability) => ability && allowedAbilities.includes(ability.subject)
    );
  }
  return false;
};
